import React from 'react';
import { ShipmentCost, ShipmentUnits } from 'src/components/ShipmentBanner';
import { OfferStatusBadge } from 'src/components/StatusBadge';
import {
  Badge,
  Card,
  CardBody,
  Icon,
  Link,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  useApp
} from 'straightline-ui';
import { formatMoney } from 'straightline-utils/accounting';
import { formatDate } from 'straightline-utils/time';

export default function ShipmentMatchesCard() {
  const app = useApp();

  const { result, isLoading, isError, error } = app
    .service('api/shipment-matches')
    .useFind(
      {
        query: {
          $limit: 20,
          $sort: { pickup_date: 1 }
        },
        $include: ['shipment_requests']
      },
      { keepPreviousData: true }
    );

  if (isLoading || isError) {
    return <Loader error={error} />;
  }

  return (
    <Card>
      <div className="card-header">
        <h3 className="card-header-title">Load Board</h3>
        <Link to="/shipment-matches">View All</Link>
      </div>
      <div className="table-responsive">
        <Table className="table table-nowrap card-table table-hover">
          <TableHead>
            <TableRow>
              <TableHeader className="px-3 px-xl-4">Payout</TableHeader>
              <TableHeader className="px-3 px-xl-4">Pickup</TableHeader>
              <TableHeader className="px-3 px-xl-4">Delivery</TableHeader>
              <TableHeader className="px-3 px-xl-4">Service</TableHeader>
              <TableHeader className="px-3 px-xl-4">Details</TableHeader>
              <TableHeader className="pr-3 pr-xl-4 pl-0"></TableHeader>
            </TableRow>
          </TableHead>
          <TableBody className="list">
            {result.data.map((match) => {
              const offer =
                match.shipment_offers &&
                match.shipment_offers[match.shipment_offers.length - 1];

              return (
                <TableRow key={match.id} to={`/shipment-matches/${match.id}`}>
                  <TableData className="px-3 px-xl-4" style={{ width: '1%' }}>
                    <div className="h1 mb-0 text-primary">
                      {formatMoney(match.rate.price.carrier_price, {
                        precision: 0
                      })}
                    </div>
                  </TableData>
                  <TableData className="px-3 px-xl-4" style={{ width: '1%' }}>
                    <p className="mb-0">
                      {match.pickup_address.city}, {match.pickup_address.state}
                    </p>
                    <p className="mb-0">
                      {formatDate(match.pickup_date, 'LLL d, yyyy')}
                    </p>
                  </TableData>
                  <TableData
                    className="px-3 px-xl-4"
                    style={{ width: '1%', position: 'relative' }}
                  >
                    <div style={{ position: 'absolute', left: -12, top: 21 }}>
                      <Icon
                        type="arrow-right text-success"
                        style={{ fontSize: 25 }}
                      />
                    </div>
                    <p className="mb-0">
                      {match.delivery_address.city},{' '}
                      {match.delivery_address.state}
                    </p>
                    <p className="mb-0">
                      {formatDate(match.due_date, 'LLL d, yyyy')}
                    </p>
                  </TableData>
                  <TableData>
                    <div>{match.rate.service_level.name}</div>
                    <ShipmentCost shipment={match} />
                  </TableData>
                  <TableData>
                    <ShipmentUnits shipment={match} />
                  </TableData>
                  <TableData
                    className="pr-3 pr-xl-4 pl-0 text-right"
                    style={{ width: '1%' }}
                  >
                    {offer && <OfferStatusBadge status={offer.status} />}
                    {match.shipment_requests > 0 && (
                      <Badge color="soft-secondary" className="ml-2">
                        {match.shipment_requests} Truck Match
                        {match.shipment_requests === 1 ? '' : 'es'}
                      </Badge>
                    )}
                  </TableData>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}

const Loader = ({ error }) => {
  return (
    <Card>
      <div className="card-header">
        <h3 className="card-header-title">Load Board</h3>
        <Link to="/shipment-matches">View All</Link>
      </div>
      <CardBody>
        {error ? (
          <div className="text-center lead text-danger pt-5 mt-5 mb-5 pb-5">
            <p className="mb-0">{error.message}</p>
          </div>
        ) : (
          <div className="chart"></div>
        )}
      </CardBody>
    </Card>
  );
};
